var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9913",
    "data-name": "Group 9913",
    transform: "translate(-1236 -360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_15x15_photo_back",
    "data-name": "15x15 photo back",
    transform: "translate(1259 388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_270",
    "data-name": "Mask Group 270",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "portrait",
    d: "M5.941,14.733a.475.475,0,0,1-.475.475H2.178A2.18,2.18,0,0,1,0,13.031V9.743a.475.475,0,0,1,.951,0v3.288a1.229,1.229,0,0,0,1.227,1.227H5.465A.475.475,0,0,1,5.941,14.733ZM.475,5.941a.475.475,0,0,0,.475-.475V2.178A1.229,1.229,0,0,1,2.178.951H5.465a.475.475,0,0,0,0-.951H2.178A2.18,2.18,0,0,0,0,2.178V5.465A.475.475,0,0,0,.475,5.941ZM13.031,0H9.743a.475.475,0,0,0,0,.951h3.288a1.229,1.229,0,0,1,1.227,1.227V5.465a.475.475,0,1,0,.951,0V2.178A2.18,2.18,0,0,0,13.031,0Zm1.7,9.268a.475.475,0,0,0-.475.475v3.288a1.229,1.229,0,0,1-1.227,1.227H9.743a.475.475,0,0,0,0,.951h3.288a2.18,2.18,0,0,0,2.178-2.178V9.743A.475.475,0,0,0,14.733,9.268ZM7.6,7.951a3.8,3.8,0,0,0-3.791,3.791.475.475,0,1,1-.951,0A4.749,4.749,0,0,1,5.85,7.337a2.817,2.817,0,1,1,3.508,0,4.749,4.749,0,0,1,2.988,4.405.475.475,0,1,1-.951,0A3.8,3.8,0,0,0,7.6,7.951ZM7.6,7A1.867,1.867,0,1,0,5.737,5.134,1.869,1.869,0,0,0,7.6,7Z",
    transform: "translate(0)",
    fill: "#8e8e8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4537",
    "data-name": "Rectangle 4537",
    transform: "translate(1236 360)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    strokeDasharray: "2 3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 70,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 59.5,
    height: 69.5,
    rx: 9.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUp);
export default __webpack_public_path__ + "static/media/imgUp.60f29ebe772c9700d2dd6eb586346115.svg";
export { ForwardRef as ReactComponent };